const DownloadByLabel = ({ url, name, label }) => {
  return (
    <a href={url} download={name}>
      <button type="button">{label}</button>
    </a>
  );
};
export default DownloadByLabel;
